import React from "react";
import { Col, Container, Row, Tab, Nav } from "react-bootstrap";
import BgImg from "../../images/services-usa/cloud-infra/diverse_cloud.webp";
import { StaticImage } from "gatsby-plugin-image";

function Zerohassle() {
  return (
    <section
      className="redefinepatient_services zero_hassle_dubai cloud_infra_tabs p-100 tekgrip_section"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <h2 style={{ color: "#314252" }}>
              TekRevol's Proficiency Across Diverse Cloud Services
            </h2>
          </Col>
        </Row>
        <Row className="mt-lg-5 mt-md-3 md-sm-2">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="tekgrip_tabs"
          >
            <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
              <Tab.Container id="" defaultActiveKey="0">
                <Row>
                  <Col xs={12} md={5} lg={4} xl={4} className="redefine_tabs">
                    <Nav variant="pills" className="flex-column">
                      <div className="red_item">
                        <Nav.Item>
                          <Nav.Link eventKey="0">
                            01. AWS Consulting Services
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="1">
                            02. GCP Consulting Services
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="2">
                            03. Azure Consulting Services
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="3">
                            04. Oracle Consulting Services
                          </Nav.Link>
                        </Nav.Item>
                      </div>
                    </Nav>
                  </Col>
                  <Col xs={12} md={7} lg={8} xl={8}>
                    <Tab.Content>
                      <Tab.Pane eventKey="0">
                        <div
                          className="cloud_infra_tabs_img"
                          style={{ marginBottom: "15px" }}
                        >
                          <StaticImage
                            src="../../images/services-usa/cloud-infra/tabs_sec/aws.webp"
                            alt="tekrevol_web"
                            layout="constrained"
                            placeholder="blurred"
                            formats={["webp"]}
                            width={94}
                            height={56}
                          />
                        </div>
                        <h3 style={{ color: "#F47A1F" }}>
                          AWS Consulting Services
                        </h3>
                        <p>
                          We help you improve the way you manage your cloud
                          infrastructure. Our expertise lies in assisting
                          companies to make the most out of AWS resources,
                          enabling them to fully capitalize on the range of
                          advantages the platform provides, from exceptional
                          scalability and flexibility to economical pricing and
                          strong security protocols.
                        </p>
                      </Tab.Pane>
                      <Tab.Pane eventKey="1">
                        <div
                          className="cloud_infra_tabs_img"
                          style={{ marginBottom: "15px" }}
                        >
                          <StaticImage
                            src="../../images/services-usa/cloud-infra/tabs_sec/cloud.webp"
                            alt="tekrevol_web"
                            layout="constrained"
                            placeholder="blurred"
                            formats={["webp"]}
                            width={78}
                            height={62}
                          />
                        </div>
                        <h3 style={{ color: "#F47A1F" }}>
                          GCP Consulting Services
                        </h3>
                        <p>
                          We are experts in providing GCP consulting services,
                          assisting companies in utilizing Google Cloud Platform
                          to meet their strategic objectives. We offer
                          professional advice to optimize Google Cloud for your
                          company, from cloud implementation and optimization to
                          data management and machine learning solutions.
                        </p>
                      </Tab.Pane>
                      <Tab.Pane eventKey="2">
                        <div
                          className="cloud_infra_tabs_img"
                          style={{ marginBottom: "15px" }}
                        >
                          <StaticImage
                            src="../../images/services-usa/cloud-infra/tabs_sec/azure.webp"
                            alt="tekrevol_web"
                            layout="constrained"
                            placeholder="blurred"
                            formats={["webp"]}
                            width={87}
                            height={67}
                          />
                        </div>
                        <h3 style={{ color: "#F47A1F" }}>
                          Azure Consulting Services
                        </h3>
                        <p>
                          Our areas of expertise include cloud strategy
                          development, Azure infrastructure design, migration
                          plan execution, application modernization, and ongoing
                          Azure environment optimization. Our expertise
                          guarantees smooth integration and effective operation
                          inside the Azure environment, customized to fulfill
                          your goals and business requirements.
                        </p>
                      </Tab.Pane>
                      <Tab.Pane eventKey="3">
                        <div
                          className="cloud_infra_tabs_img"
                          style={{ marginBottom: "15px" }}
                        >
                          <StaticImage
                            src="../../images/services-usa/cloud-infra/tabs_sec/oracle.webp"
                            alt="tekrevol_web"
                            layout="constrained"
                            placeholder="blurred"
                            formats={["webp"]}
                            width={72}
                            height={54}
                          />
                        </div>
                        <h3 style={{ color: "#F47A1F" }}>
                          Oracle Consulting Services
                        </h3>
                        <p>
                          We provide specialist Oracle consulting services.
                          Whether it's cloud deployment, database
                          administration, performance optimization, or
                          compliance—our Oracle specialists offer customized
                          solutions to improve productivity, security, and
                          scalability in your Oracle environment.
                        </p>
                      </Tab.Pane>
                    </Tab.Content>
                  </Col>
                </Row>
              </Tab.Container>
            </Col>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Zerohassle;
